import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import BlockLayout from "../Layout/BlockLayout";
import Autocomplete, {
  createFilterOptions
} from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
import { Container, Row, Col, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { municipalities } from "../../data/kommuner";
import Switch from "@mui/material/Switch";

import {
  findUsersMunicipality,
  getCurrentPosition,
  checkPermission,
  handleError
} from "../../data/GeoApi";
import Message from "./Message";

import {
  ptSerif,
  Inter,
  lineheight34,
  letterSpacingPT_serif
} from "../../Util/StyleProps";
import { primaryColor, secondaryColor } from "../../Util/Colors";

const municipalitySelectorDefault = municipalities();
municipalitySelectorDefault.unshift({ id: 0, name: "Din position" });
var municipalitySelector = [];

const Heading = styled.h2`
  font-family: ${Inter};
  letter-spacing:  -0.15px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  margin: 0px;

`;

const TextFieldWrapper = styled.div`

`;

const ButtonWrapper = styled.div`
  .btn-primary:hover {
    background-color: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.20), 0 1px 3px 1px rgba(0, 0, 0, 0.15);
  }

  .btn-primary:not(:disabled):not(.disabled):active,
  .show > .btn-primary.dropdown-toggle {
    background-color: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
    opacity: .82;
  }

  .btn-primary:disabled {
    svg{
    fill: #928fb8;
    }
    background-color: rgba(15, 8, 101, 0.12) !important;
    border: none;
    color:#928fb8;
    text-decoration:none;
    :hover{
      box-shadow: none;
    }
  }

  & button {
    border-radius: 25px;
    margin-top: 24px;
    padding: 8px 24px;
    line-height: 24px;
    background-color: ${primaryColor};
    border-color: ${primaryColor};
    font-family: ${Inter};
    font-weight: 600;
    font-size: 16px;
    display: flex;
    gap: 8px;
    place-items: center;
  }

 
`;

const MunicipalityWrapper = styled.div`
border-radius: 24px;
background: #EBF8FF;
padding: 32px;
max-width: 600px;
& label {
  margin-bottom: 8px;
}
.second-input{
  width: 100%;
  max-width: 240px;
  @media${device.tablet}{
  margin-top: 0;
  }
}
.first-input {
    width: 100%;
    max-width: 240px;
}
.MuiFormControl-marginNormal {
  margin-bottom: 0;
  margin-top: 0 !important;
}
// Line under input-field

.MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom: 1px solid ${primaryColor};
    border-bottom-color: ${primaryColor};
    opacity: 0.47;
}

& input {
  color: #0F0865;
  font-family: ${Inter};
  letter-spacing: -0.3px;
  font-size: 18px;
  line-height: 26px;
  background: #FFF;
  ::placeholder {
    opacity: 1;
  }
}
fieldset{
  border: 1px solid #808080;
  border-radius:8px;
}
    display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 32px;
@media${device.tablet}{

  .MuiInput-underline:before {
    bottom:2px !important;
}

  & input {
    flex: 1 0 50%;
    font-size: 18px;
    line-height: 26px;
  }
  & label {
    flex: 1 0 50%;
    line-height: 50px;
  }
}
`;

const classes = {
  root: {
    width: 300,
    fontSize: 20
  },
  TextField: {
    "& input": {
      color: "#0F0865",
      width: 0,
      padding: 0
    },
    "& .MunicipalitySelector-Autocomplete-4": {
      marginBottom: 0,
      marginTop: 0,
      lineHeight: 42
    },
    "& svg": {
      color: "#0F0865"
    }
  },
  Autocomplete: {
    alignContent: "center",
    lineHeight: 0,
    background: "#FFF",
    borderRadius: "8px",
    "& span": {
      width: "100%"
    }
  },
  option: {
    "& > span": {
      marginRight: 10,
      fontSize: 30
    }
  }
};

export class MunicipalitySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      municipalityid1: props.requestedMunicipalities["1"]
        ? props.requestedMunicipalities["1"].id
        : null,
      municipalityid2: props.requestedMunicipalities["2"]
        ? props.requestedMunicipalities["2"].id
        : null,
      municipalityname1: props.requestedMunicipalities["1"]
        ? props.requestedMunicipalities["1"].name
        : null,
      municipalityname2: props.requestedMunicipalities["2"]
        ? props.requestedMunicipalities["2"].name
        : null,
      hasmessage: false,
      message: null,
      municipalitySelector: municipalitySelectorDefault,
      hasAcceptedGeoTracking: false,
      userCurrentMuncipality: props.requestedMunicipalities["1"],
      userCurrentMuncipality2: props.requestedMunicipalities["2"]
    };
    this.onMunicipalityChange1 = this.onMunicipalityChange1.bind(this);
    this.onMunicipalityChange2 = this.onMunicipalityChange2.bind(this);
    this.toogleGeoPosition = this.toogleGeoPosition.bind(this);
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (this.state.municipalityid1 || this.state.municipalityid2) {
      this.preloadMuncicipality();
    } else {
      if (!isSafari) {
        this.checkIfUserHasAcceptedGeoTracking();
      }
    }
  }

  preloadMuncicipality = async () => {
    await this.fetchMunicipalityData();
  };

  getUsersGeoMuncicipality = async () => {
    try {
      const { coords } = await getCurrentPosition();
      municipalitySelector = await findUsersMunicipality(
        coords.latitude,
        coords.longitude
      );
      this.updateMunicipalityUrl(municipalitySelector[0].id, this.state.municipalityid2);

      this.setState({
        hasAcceptedGeoTracking: true,
        municipalityid1: municipalitySelector[0].id,
        municipalityname1: municipalitySelector[0].name,
        userCurrentMuncipality: municipalitySelector[0],
        municipalitySelector: municipalitySelector
      });
    } catch (error) {
      var msg = null;

      switch (error.code) {
        case error.PERMISSION_DENIED:
          msg =
            "Du måste tillåta webbläsaren att känna av var du befinner dig. Det gör du i webbläsarens inställningar.";
          break;
        case error.POSITION_UNAVAILABLE:
          msg =
            "Vi hittar tyvärr inte din plats, du får välja din egen position.";
          break;
        case error.UNKNOWN_ERROR:
          msg = "Något gick fel, försök igen.";
          break;
        default:
          msg = "Något gick fel, försök igen.";
      }
      this.setState({
        hasmessage: true,
        message: msg
      });
    }
  };
  //Checks whether the user has previously approved geo-positioning
  checkIfUserHasAcceptedGeoTracking = async () => {
    var permission = await checkPermission();
    if (permission === "granted") {
      this.getUsersGeoMuncicipality();
    } else {
      this.setState({
        municipalitySelector: municipalitySelectorDefault
      });
    }
  };

  fetchMunicipalityData = () => {
    this.props.datahandler([
      this.state.municipalityid1,
      this.state.municipalityid2
    ]);
  };

  updateMunicipalityUrl = (m1, m2) => {
    if (window.history.pushState) {
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?id1=" +
        m1 +
        "&id2=" +
        m2;
      window.history.pushState({ path: newurl }, "", newurl);
    }
  };

  onMunicipalityChange1 = (event, object) => {
    if (object) {
      if (object.id === 0) {
        this.getUsersGeoMuncicipality();
      } else {
        this.updateMunicipalityUrl(object.id, this.state.municipalityid2);
        this.setState({
          municipalityid1: object.id,
          municipalityname1: object.name,
          userCurrentMuncipality: object
        });
      }
    } else {
      this.updateMunicipalityUrl(null, this.state.municipalityid2);
      this.setState({
        municipalityid1: null,
        municipalityName1: null,
        userCurrentMuncipality: null
      });
    }
  };

  onMunicipalityChange2 = (event, object) => {
    if (object) {
      this.updateMunicipalityUrl(this.state.municipalityid1, object.id);
      this.setState({
        municipalityid2: object.id,
        municipalityname2: object.name,
        userCurrentMuncipality2: object
      });
    } else {
      this.updateMunicipalityUrl(this.state.municipalityid1, null);
      this.setState({
        municipalityid2: null,
        municipalityName2: null,
        userCurrentMuncipality2: object
      });
    }
  };

  //Gives the user a choice to enable geopositioning
  toogleGeoPosition() {
    if (this.state.hasAcceptedGeoTracking) {
      this.setState({ hasmessage: true });
      this.setState({
        message:
          "Om du vill stänga av positionering, måste du göra det i din webbläsare."
      });
    } else {
      this.getUsersGeoMuncicipality();
    }
  }

  handleClickMessageBox = () => {
    this.setState({ hasmessage: false });
  };

  render() {
    return (
      <BlockLayout paddingBottom="32px" marginMobile="0 0 16px 0">
        <Message
          heading="Vi kan inte se var du är!"
          message={this.state.message}
          show={this.state.hasmessage}
          handleClickMessageBox={this.handleClickMessageBox}
        />
        <MunicipalityWrapper ref={this.props.refMunicipalitySelector}>
          <div className="first-input">
            <Form.Label>
              <Heading>Jag vill se kommunen</Heading>
            </Form.Label>

            <Autocomplete
              id="municipality1"
              onChange={this.onMunicipalityChange1}
              className={this.props.classes.Autocomplete}
              options={this.state.municipalitySelector}
              value={this.state.userCurrentMuncipality}
              getOptionLabel={option => option.name}
              getOptionDisabled={option =>
                option.id === this.state.municipalityid2
              }
              filterOptions={createFilterOptions({
                matchFrom: "start",
                stringify: option => option.name
              })}
              popupIcon={
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="#0F0865"/>
              </svg>
              }
              renderInput={params => (
                <TextFieldWrapper>
                  <TextField
                    className={this.props.classes.TextField}
                    {...params}
                    placeholder="Välj kommun"
                    margin="normal"
                    fullWidth
                  />
                </TextFieldWrapper>
              )}
            />
          </div>
          <div className="second-input">
            <Form.Label>
              <Heading>... och jämföra den med</Heading>
            </Form.Label>

            <Autocomplete
              id="municipality2"
              onChange={this.onMunicipalityChange2}
              className={this.props.classes.Autocomplete}
              options={municipalitySelectorDefault}
              value={this.state.userCurrentMuncipality2}
              getOptionLabel={option => option.name}
              getOptionDisabled={option =>
                option.id === this.state.municipalityid1
              }
              filterOptions={createFilterOptions({
                matchFrom: "start",
                stringify: option => option.name
              })}
              popupIcon={
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="#0F0865"/>
              </svg>
              }
              renderInput={params => (
                <TextFieldWrapper>
                  <TextField
                    className={this.props.classes.TextField}
                    {...params}
                    placeholder="Välj kommun"
                    margin="normal"
                    fullWidth
                  />
                </TextFieldWrapper>
              )}
            />
          </div>
        </MunicipalityWrapper>
        
        <ButtonWrapper>
          <Button
            onClick={this.fetchMunicipalityData}
            className={this.props.classes.Button}
            disabled={
              this.state.municipalityid1 || this.state.municipalityid2
                ? false
                : true
            }
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFF"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg>
            Visa kommunsiffror
          </Button>
        </ButtonWrapper>
      </BlockLayout>
    );
  }
}
export default withStyles(classes)(MunicipalitySelector);
